import {useContext} from 'react'
import {DocumentLoadDetailContext} from '../DocumentLoadDetailContext'
import { KTIcon } from '../../../../../../_metronic/helpers'

const DocumentDetailModalHeader = () => {
  const {closeDocumentDetailModal} = useContext(DocumentLoadDetailContext)

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Detalle del Documento</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => closeDocumentDetailModal()}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {DocumentDetailModalHeader}
